/* eslint-disable camelcase */
import * as THREE from 'three'
import { createRectsMeshes } from '../utils/helper_functions'

export const drawOvalStanding = (group, options) => {
  const {
    x,
    y,
    width,
    height,
    inner_width: innerWidth,
    inner_height: innerHeight,
    rotation,
    rect_type: rectType
  } = group
  const { color, scale, opacity = 1 } = options

  const isTopRect = rectType === 'top_rect'
  const [horizontal_w, horizontal_h] = [width, (height - innerHeight) / 2]
  const [vertical_w, vertical_h] = [(width - innerWidth) / 2, height]

  let rects = [
    {
      width: horizontal_w,
      height: horizontal_h,
      x,
      y: y + (innerHeight / 2 + horizontal_h / 2)
    },
    {
      width: vertical_w,
      height: vertical_h,
      x: x + (innerWidth / 2 + vertical_w / 2),
      y
    },
    {
      width: vertical_w,
      height: vertical_h,
      x: x - (innerWidth / 2 + vertical_w / 2),
      y
    }
  ]

  if (isTopRect) {
    rects = [
      {
        width: horizontal_w,
        height: horizontal_h,
        x,
        y: -(y + (innerHeight / 2 + horizontal_h / 2))
      },
      {
        width: vertical_w,
        height: vertical_h,
        x: x + (innerWidth / 2 + vertical_w / 2),
        y: -y
      },
      {
        width: vertical_w,
        height: vertical_h,
        x: x - (innerWidth / 2 + vertical_w / 2),
        y: -y
      }
    ]
  }

  const { rectMeshes, ring } = createRectsMeshes(rects, options)

  const drawRingBorder = () => {
    const lineBasicMaterial = new THREE.LineBasicMaterial({
      color,
      opacity,
      transparent: true
    })

    const geometry = new THREE.PlaneGeometry(width * scale, height * scale)

    const delta = ((width - innerWidth) * scale) / 2
    const geometryArray = []
    const { array: gArray } = geometry?.attributes?.position
    geometryArray.push(
      new THREE.Vector3(gArray[0], gArray[1], 0),
      new THREE.Vector3(gArray[0] + delta, gArray[1], 0),
      new THREE.Vector3(gArray[6] + delta, gArray[7] + delta, 0),
      new THREE.Vector3(gArray[9] - delta, gArray[10] + delta, 0),
      new THREE.Vector3(gArray[3] - delta, gArray[4], 0),
      new THREE.Vector3(gArray[3], gArray[4], 0),
      new THREE.Vector3(gArray[9], gArray[10], 0),
      new THREE.Vector3(gArray[6], gArray[7], 0),
      new THREE.Vector3(gArray[0], gArray[1], 0)
    )

    const lineGeometry = new THREE.BufferGeometry().setFromPoints(geometryArray)
    const line = new THREE.Line(lineGeometry, lineBasicMaterial)

    if (isTopRect) {
      line.position.set(x * scale, y * scale, 0)
      line.rotation.set(0, 0, (rotation * Math.PI) / 180)
    } else {
      line.position.set(x * scale, -y * scale, 0)
    }

    ring.add(line)
    ring.borderLines = [line]
  }

  drawRingBorder()

  return { standingArea: ring, rectMeshes }
}
